import { riskConfig } from '@/components/risk_management/riskConfig'
import { formatAxisLevel, formatRiskScoreStr } from '@/components/risk_management/shared'
import { getTreatmentText } from '@/services/utils'

export function riskScore(_: string | undefined, __: string, value: string) {
	if (!value) return ''

	const num = Number.parseFloat(value)
	return formatRiskScoreStr(num, 1)
}

export function riskAxisLevel(_: string | undefined, field: string, value: string) {
	if (!value) return ''

	const num = Number.parseFloat(value)
	const num2 = formatAxisLevel(num)

	if (field == 'impact') return riskConfig.value.riskImpacts[num2].title
	else if (field == 'probability') return riskConfig.value.riskProbabilities[num2].title
	else return num2.toFixed()
}

export function riskTreatment(_: string | undefined, __: string, value: string) {
	return getTreatmentText(value)
}
